import { render } from "./AppFaceRecognition.vue?vue&type=template&id=d7f0397e&scoped=true"
import script from "./AppFaceRecognition.vue?vue&type=script&lang=js"
export * from "./AppFaceRecognition.vue?vue&type=script&lang=js"

import "./AppFaceRecognition.vue?vue&type=style&index=0&id=d7f0397e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7f0397e"]])

export default __exports__